import React, { useCallback, useEffect, useState } from "react";
import { Dialog, Pane, SearchInput, Text } from "evergreen-ui";
import POsList from "./POsList";
import useDebounce from "../hooks/useDebounce";
import useControlHub from "../hooks/useControlHub";

const POMatchDialog = ({
  isShown,
  invoiceID,
  onCancel,
  onClose,
  onConfirm,
  onOpen,
}) => {
  const { api } = useControlHub();
  const [pos, setPOs] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [poID, setPOID] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isShown) {
      return;
    }
    api
      .getPurchaseOrders({ search: debouncedSearch })
      .then((data) => {
        if (!data.success) {
          throw new Error("Couldn't fetch POs to match");
        }
        setPOs(data.response.results);
      })
      .catch(() => {
        setPOs([]);
      });
  }, [api, debouncedSearch, isShown]);

  const handleConfirm = useCallback(() => {
    setLoading(true);
    api
      .createBill({
        invoiceID,
        data: {
          match: poID ? true : false,
          po_id: poID,
        },
      })
      .then((data) => {
        setLoading(false);
        if (!data || !data.success) {
          throw new Error("Couldn't match PO to Invoice");
        }
        onConfirm(poID);
      })
      .catch(() => {
        setLoading(false);
        setPOID("");
        onConfirm("failed_to_match");
      });
  }, [api, invoiceID, onConfirm, poID]);

  const handlePOSelect = useCallback((po) => {
    setPOID(po?.["id"] || "");
  }, []);

  const handleSearchInputChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <Dialog
      isShown={isShown}
      isConfirmLoading={loading}
      onCancel={onCancel}
      onCloseComplete={onClose}
      onConfirm={handleConfirm}
      onOpenComplete={onOpen}
      cancelLabel="Back"
      confirmLabel={poID ? "Match" : "Skip"}
      title="Match to PO"
    >
      <Pane display="flex" flexDirection="column" alignItems="center">
        <Pane
          background="white"
          boxShadow="0 5px 15px -15px"
          display="flex"
          marginX={-16}
          padding={16}
          position="sticky"
          top={-16}
        >
          <Text size={300} paddingRight={32}>
            Search by Vendor, Request Name or Token, Biz Owner, Keyword...
          </Text>
          <SearchInput
            onChange={handleSearchInputChange}
            placeholder="Search POs"
          />
        </Pane>
        <POsList
          onSelect={handlePOSelect}
          paneProps={{
            border: true,
            marginY: 16,
            paddingBottom: 8,
            overflowY: "scroll",
            width: "100%",
          }}
          pos={pos}
        />
      </Pane>
    </Dialog>
  );
};

export default POMatchDialog;
